// Define a default UI for filtering
import React from 'react';
import {GreenButton, WhiteButton, StyledSelect2} from '@styled';

const filterOperators = [
  {value: '~eq~', label: 'Is equal to'},
  {value: '~neq~', label: 'Is not equal to'},
  {value: '~startswith~', label: 'Starts with'},
  {value: '~endswith~', label: 'Ends with'},
  {value: '~contains~', label: 'Contains'},
  {value: '~doesnotcontains~', label: 'Does not contains'},
  {value: '~isnull~', label: 'Is null'},
  {value: '~isnotnull~', label: 'Is not null'},
  {value: '~isempty~', label: 'Is empty'},
  {value: '~isnotempty~', label: 'Is not empty'},
  {value: '~isnullorempty~', label: 'Has no value'},
  {value: '~isnotnullorempty~', label: 'Has value'},
];

const DefaultColumnFilter = ({column: {filterValue, setFilter, id}}) => {
  // const count = preFilteredRows.length;
  const [searchText, setSearchText] = React.useState(
    filterValue ? filterValue.text : ''
  );

  const defaultOp = filterValue ? filterValue.op : '~contains~';

  const [selectedOperator, setSelectedOperator] = React.useState(
    filterOperators.find((item) => item.value === defaultOp)
  );

  const handleOpChange = (val) => {
    setSelectedOperator(val);
  };

  return (
    <div style={{minWidth: '200px'}}>
      <div>
        <StyledSelect2
          name="filter-operators"
          options={filterOperators}
          value={selectedOperator}
          onChange={handleOpChange}
        />
      </div>
      <div style={{marginTop: '10px'}}>
        <input
          value={searchText}
          onChange={(e) => {
            setSearchText(e.target.value);
          }}
          placeholder="Search by typing..."
          className="form-control"
        />
      </div>
      <div style={{marginTop: '10px'}}>
        <GreenButton
          style={{marginRight: '10px'}}
          onClick={() => {
            setFilter(
              searchText
                ? {op: selectedOperator.value, text: searchText}
                : undefined
            );
            document.getElementById(`filter-menu-toggle-${id}`).click();
          }}
        >
          Filter
        </GreenButton>
        <WhiteButton
          onClick={() => {
            setFilter(undefined);
            document.getElementById(`filter-menu-toggle-${id}`).click();
          }}
        >
          Clear
        </WhiteButton>
      </div>
    </div>
  );
};
export default DefaultColumnFilter;
